// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const _404_TITLE = "Ups, t\u00e1to podstr\u00e1nka neexistuje";
